var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33334 3.125C8.85417 3.125 10.9375 7.8125 10.9375 8.33333C10.9375 9.375 9.37501 10.4167 8.85417 11.4583C8.33334 12.5 9.37501 13.5417 10.4167 14.5833C10.8229 14.9896 12.5 16.6667 13.5417 16.1458C14.5833 15.625 15.625 14.0625 16.6667 14.0625C17.1875 14.0625 21.875 16.1458 21.875 16.6667C21.875 18.75 20.3125 20.3125 18.75 20.8333C17.1875 21.3542 16.1458 21.3542 14.0625 20.8333C11.9792 20.3125 10.4167 19.7917 7.81251 17.1875C5.20834 14.5833 4.68751 13.0208 4.16667 10.9375C3.64584 8.85417 3.64584 7.8125 4.16667 6.25C4.68751 4.6875 6.25001 3.125 8.33334 3.125Z",
    stroke: "#9A8784",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ebc2064da2a342d452e09301ec2ab4d3.svg";
export { ForwardRef as ReactComponent };